<template>
  <div class="r-submit-wait">
    <Modal
      footer-hide
      v-model="show"
      width="750"
      :closable="false"
      :mask-closable="false"
    >
      <div class="box">
        <div class="iconfont iconwancheng" v-if="num == list.length"></div>
        <div class="iconfont icontijiao" v-else></div>
        <div
          class="common-flex title common-justify-center common-align-center"
        >
          <div>{{ $t("saveItems.submitting") }} ({{ list.length }}/{{ num }})</div>
          <!-- <div>{{$t('saveItems.completed')}}</div> -->
        </div>
        <div class="loading-list">
          <div
            v-for="(item, index) in list"
            :key="index"
            class="common-flex common-justify-between"
          >
            <div
              class="common-flex common-align-center"
              :style="
                item.status == 2
                  ? { color: '#0C750E' }
                  : item.status == 3
                  ? { color: '#C9000F' }
                  : { color: '#000' }
              "
            >
              <!-- 等待上传 -->
              <div
                v-if="item.status == 0"
                class="iconfont icontijiao"
                style="font-size: 14px; margin-bottom: 0; color: #081938"
              ></div>
              <!-- 1等待 -->
              <div
                v-if="item.status == 1"
                class="iconfont icontijiao"
                style="font-size: 14px; margin-bottom: 0; color: #081938"
              ></div>
              <!-- 2成功 -->
              <div v-if="item.status == 2">
                <Icon type="ios-checkmark-circle-outline" />
              </div>
              <!-- 3失败 -->
              <div v-if="item.status == 3">
                <Icon type="ios-close-circle-outline" />
              </div>
              <div style="margin: 0 20px 0 9px">{{ item.orderCode }}</div>
              <Tooltip v-if="item.status == 3"  :content="item.msg"  placement="top"  style="height: 20px">
                <div v-if="item.status == 3" class="msg-container">{{ item.msg }}</div>
              </Tooltip>
            </div>
            <div v-if="item.status == 3">Failed</div>
            <div v-if="item.status == 1">{{ $t("cart.Uploading") }}...</div>
            <div style="color: #0c750e" v-if="item.status == 2">Success</div>
          </div>
          <!-- <div
            class="common-flex common-justify-between"
            style="color: #0c750e"
          >
            <div class="common-flex common-align-center">
              <div><Icon type="ios-checkmark-circle-outline" /></div>
              <div style="margin: 0 20px 0 9px">ACE210200012POLL-21</div>
            </div>
            <div>Success</div>
          </div>
          <div
            class="common-flex common-justify-between"
            style="color: #081938"
          >
            <div class="common-flex common-align-center">
              <div
                class="iconfont icontijiao"
                style="font-size: 14px; margin-bottom: 0; color: #081938"
              ></div>
              <div style="margin: 0 20px 0 9px">ACE210200012POLL-21</div>
            </div>
          </div> -->
        </div>
        <div class="loading-nums common-flex common-flex-end">
          <div>
            {{ $t("saveItems.success") }}:<span style="color: #0c750e">{{
              success
            }}</span>
          </div>
          <div>
            {{ $t("saveItems.fail") }}:<span style="color: #c9000f">{{
              fail
            }}</span>
          </div>
        </div>
        <div class="common-flex common-flex-end">
          <Button
            class="close"
            :disabled="list.length !== num"
            @click="close"
            >{{ $t("saveItems.close") }}</Button
          >
          <Button
            class="order"
            :disabled="list.length !== num"
            @click="order"
            type="primary"
            >{{ $t("saveItems.myOrder") }}</Button
          >
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "r-submit-wait",
  data() {
    return {
      show: false,
      list: [],
      num: 0,
      success: 0,
      fail: 0,
      returnData: [],
    };
  },
  watch: {
    submitShow: {
      handler(newval, oldval) {
        this.show = newval;
        this.handleSubmit();
        // this.returnData = [];
        // if (newval) {
        //   console.log("this.submitIds", this.submitIds);
        //   this.num = 0;
        //   this.success = 0;
        //   this.fail = 0;
        //   this.list = this.submitIds;
        //   for (let i = 0; i < this.list.length; i++) {
        //     this.list[i].status = 1;
        //     // this.list.map(item=>{
        //     this.pushOrderAction({ orderIds: this.list[i].orderId + "," })
        //       .then((res) => {
        //         console.log("res", res);
        //         Object.keys(res.data).map((key) => {
        //           this.returnData.push(res.data[key]);
        //         });
        //         if (res.code == 0) {
        //           this.list[i].status = 2;
        //           this.success++;
        //         } else if (res.code == 1) {
        //           this.list[i].status = 3;
        //           this.list[i].msg = res.message;
        //           this.fail++;
        //         }
        //       })
        //       .catch((res) => {
        //         this.list[i].status = 3;
        //         // this.list[i].msg = res.message||'';
        //         this.list[i].msg = '';
        //         this.fail++;
        //         this.returnData.push({});

        //       })
        //       .then((res) => {
        //         this.num++;
        //       });
        //   }
        //   // })
        //   console.log(this.list);
        // } else {
        //   this.$emit("close");
        // }
      },
      immediate: true,
    },
    show: {
      handler(newval, oldval) {
        if (newval == false) {
          this.$emit("handlerSubmitShow", newval);
        }
      },
      immediate: true,
    },
  },
  methods: {
    ...mapActions([
      "pushOrderAction", //提交订单
    ]),
    close() {
      this.$emit("close");
    },
    order() {
      this.close();
      let isFail = this.returnData.find(
        (item) => item.sign && item.sign === "fail"
      );
      if (isFail) {
        this.$router.push("/myOrder");
      } else {
        this.$router.push("/underProduction");
      }
    },
    handleRecursionSubmiting(i) {
      this.list[i].status = 1;
      this.pushOrderAction({ orderIds: this.list[i].orderId + "," })
        .then((res) => {
          if(res.data){
            Object.keys(res.data).map((key) => {
              let item =res.data[key];
              this.returnData.push(item);
              if(item.code==1||item.sign==='fail'){
                this.list[i].status = 3;
                this.list[i].msg = item.msg;
                this.fail++;
              }else{
                this.list[i].status = 2;
                this.success++;
              }
            });
          }
        })
        .catch((res) => {
          this.list[i].status = 3;
          this.list[i].msg = "";
          this.fail++;
          this.returnData.push({});
        })
        .then((res) => {
          this.num++;
          i++;
          if (i >= this.list.length) return false;
          this.handleRecursionSubmiting(i);
        });
    },
    handleSubmit() {
      this.returnData = [];
      if (this.submitShow) {
        this.num = 0;
        this.success = 0;
        this.fail = 0;
        this.list = this.submitIds;
        let i = 0;
        this.handleRecursionSubmiting(i);
      } else {
        this.$emit("close");
      }
    },
  },
  props: {
    submitShow: Boolean,
    submitIds: Array,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.box {
  width: 690px;
  margin-top: 54px;
  text-align: center;
  .icontijiao {
    font-size: 54px;
    color: #0a4dcc;
    margin-bottom: 27px;
  }
  .iconwancheng {
    font-size: 54px;
    color: #0c750e;
    margin-bottom: 27px;
  }
  .title {
    font-size: 24px;
    font-weight: 600;
    text-align: center;
    color: #081938;
    line-height: 32px;
    span {
      font-size: 16px;
      font-weight: 400;
    }
  }
  .loading-list {
    width: 690px;
    padding: 14px 30px 30px 30px;
    font-size: 14px;
    background: #f8f8f8;
    margin-top: 30px;
    > div {
      margin-top: 16px;
    }
  }
  .loading-nums {
    margin-top: 10px;
    font-size: 14px;
    font-family: Roboto, Roboto-Regular;
    font-weight: 400;
    text-align: left;
    color: #081938;
    line-height: 22px;
    margin-bottom: 42px;
    > div {
      margin-left: 18px;
    }
  }
  .close {
    background: #b5bac4;
    border-radius: 0;
    font-size: 14px;
    width: 116px;
    height: 40px;
    line-height: 40px;
    color: #fff;
  }
  .order {
    background: #0a4dcc;
    border-radius: 0;
    font-size: 14px;
    width: 116px;
    height: 40px;
    line-height: 40px;
    color: #fff;
    margin-left: 14px;
  }
  .msg-container {
    white-space: nowrap; /* 禁止换行 */
    overflow: hidden; /* 隐藏超出内容 */
    text-overflow: ellipsis; /* 超出显示省略号 */
    max-width: 400px; /* 固定最大宽度 */
    display: inline-block; /* 必须是行内块元素 */
  }
}
</style>



// WEBPACK FOOTER //
// src/components/r-submit-wait.vue